import {combineReducers} from "redux";
import loginReducer from "./LoginReducer";
import AuditSchedule from "./auditScheduleReducer";
import AuditCheckList from "./auditChecklistReducer";
import sidebarItems from "./sidebarItemsReducer";
import ELLPR from "./engineLLPReducer";
import token from "./TokenReducer"
import AvailableLeave from "./availableLeaveReducer"
import LeavePolicy from "./leavePolicyReducer";
import PublicHoliday from "./publicHolidayReducer";
import Alerts from "./alertReducer";
import CalendarEvents from "./calendarEventsReducer";
import EmployeeMessages from "./messagesReducer";
import procDemand from "./demandReducer";
 
const initialState = {
  sidebarShow: true,
}
const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}
const rootReducer = combineReducers({
  nav: changeState,
  auditSchedule: AuditSchedule,
  loginUser: loginReducer,
  auditChecklist: AuditCheckList,
  sidebarItems: sidebarItems,
  ellps: ELLPR,
  token: token,
  availableLeave: AvailableLeave,
  leavePolicy: LeavePolicy,
  publicHolidays: PublicHoliday,
  alerts: Alerts,
  calendarEvents: CalendarEvents,
  messages: EmployeeMessages,
  procDemand: procDemand,
});
export default rootReducer;
